export default {
  'pointHistory.title': '點數記錄',
  'pointHistory.event.deduct': '扣點',
  'pointHistory.event.collect': '集點',
  'pointHistory.event.transfer': '轉贈',
  'pointHistory.event.0': '不符發點',
  'pointHistory.event.1': '滿額發點',
  'pointHistory.event.4': '彈性發點',
  'pointHistory.event.10': '彈性扣點',
  'pointHistory.event.20': '自動轉券扣點',
  'pointHistory.event.21': '自由選券扣點',
  'pointHistory.event.22': '點數逾期',
  'pointHistory.event.90': '取消集點',
  'pointHistory.event.91': '取消交易扣點',
  'pointHistory.event.92': '取消交易-自動轉券點數返還',
  'pointHistory.event.93': '取消發點',
  'pointHistory.event.94': '取消扣點',
  'pointHistory.message.cancel_success': '取消集點成功',
  'pointHistory.message.cancel_fail': '取消集點成功',
  'pointHistory.current_points': '目前點數',
  'pointHistory.expiration_date': '到期日',
  'pointHistory.button.cancel': '取消',
  'pointHistory.empty': '無資料',
  'pointHistory.point_detail': '點數詳情',
  'pointHistory.processing_time': '處理時間',
  'pointHistory.remark': '備註',
  'pointHistory.consumption_amount': '消費金額',
  'pointHistory.bottomDateRange.dateFrom': '開始日期',
  'pointHistory.bottomDateRange.dateTo': '結束日期',
  'pointHistory.bottomDateRange.error.dateFrom': '請選擇開始日期',
  'pointHistory.bottomDateRange.error.dateTo': '請選擇結束日期',
  'pointHistory.bottomDateRange.error.dateRange': '開始日期不能晚於結束日期',
  'pointHistory.bottomDateRange.search': '搜尋',
  'pointHistory.bottomDateRange.cancel': '取消',
} as Record<string, string>;
